import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { StyledTable, StickyTable } from './styles';
import { TableHeaders } from './TableHeaders';
import { TableRow } from './TableRow';
import { useCurrentBreakpoint } from '../../utilities/hooks/useCurrentBreakpoint';
import { sizes } from '../../utilities/media';
export var Table = function (props) {
  var headers = props.headers,
    data = props.data,
    isHighlight = props.isHighlight,
    isExpandableRow = props.isExpandableRow,
    ExpandableComponent = props.ExpandableComponent,
    onRowActionClick = props.onRowActionClick,
    onRowClick = props.onRowClick,
    isClickableRowAction = props.isClickableRowAction,
    isClickableRow = props.isClickableRow,
    sortBy = props.sortBy,
    onSortChange = props.onSortChange,
    stickyColumnAtBreakpoint = props.stickyColumnAtBreakpoint;
  var currentBreakpoint = useCurrentBreakpoint();
  var isViewportBigger = function (bp) {
    return bp ? sizes[currentBreakpoint] > sizes[bp] : false;
  };
  var showArrows = !!(ExpandableComponent || onRowActionClick);
  var filterHeadersByBreakpoint = useCallback(function (headers) {
    return headers.filter(function (_a) {
      var hideBelowBreakpoint = _a.hideBelowBreakpoint;
      return hideBelowBreakpoint ? sizes[hideBelowBreakpoint] < sizes[currentBreakpoint] : true;
    });
  }, [currentBreakpoint]);
  var renderBody = function (headers, data, options) {
    return data.map(function (item, rowIndex) {
      return _jsx(TableRow, {
        headers: filterHeadersByBreakpoint(headers),
        item: item,
        options: options,
        rowIndex: rowIndex,
        showArrows: showArrows,
        showStickyCols: !isViewportBigger(stickyColumnAtBreakpoint)
      }, "row-".concat(rowIndex));
    });
  };
  var table = _jsxs(StyledTable, {
    children: [_jsx("thead", {
      children: _jsx(TableHeaders, {
        headers: filterHeadersByBreakpoint(headers),
        sortBy: sortBy,
        onSortChange: onSortChange,
        showArrows: showArrows,
        showStickyCols: !isViewportBigger(stickyColumnAtBreakpoint)
      })
    }), _jsx("tbody", {
      children: renderBody(headers, data, {
        isHighlight: isHighlight,
        isExpandableRow: isExpandableRow,
        ExpandableComponent: ExpandableComponent,
        onRowActionClick: onRowActionClick,
        onRowClick: onRowClick,
        isClickableRowAction: isClickableRowAction,
        isClickableRow: isClickableRow
      })
    })]
  });
  if (stickyColumnAtBreakpoint && !isViewportBigger(stickyColumnAtBreakpoint)) {
    return _jsx(StickyTable, {
      children: table
    });
  }
  return table;
};